export default __webpack_public_path__ + "static/media/file.ae6d6000.svg";